module.exports = __webpack_public_path__ + "static/media/ha2.f97833e4.jpg";